export default __webpack_public_path__ + "static/media/logo-light.27ea19a5.svg";